var _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudHosting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 45,
    viewBox: "0 0 44 45",
    width: 44,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 9.17188,
    x2: 29.0495,
    y1: 30.7863,
    y2: -0.660447
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4312a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25638,
    stopColor: "#6233df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#849bff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22 14.1006c-1.3719.0014-2.7171.3791-3.8893 1.0919-1.1722.7129-2.1263 1.7336-2.7587 2.9511-1.4691.1596-2.8276.8557-3.8152 1.955-.9876 1.0992-1.5349 2.5242-1.5368 4.002-.00013.788.155 1.5682.4565 2.2962.3014.7281.7434 1.3895 1.3006 1.9467.5571.5572 1.2186.9991 1.9466 1.3006.7281.3015 1.5083.4566 2.2963.4565h13c.6566 0 1.3068-.1293 1.9134-.3806s1.1578-.6196 1.6221-1.0839.8326-1.0155 1.0839-1.6221.3806-1.2568.3806-1.9134c-.0015-1.2653-.4827-2.483-1.3466-3.4075-.8639-.9246-2.0461-1.4872-3.3084-1.5745-.342-1.6965-1.2601-3.2226-2.5988-4.3194-1.3387-1.0969-3.0156-1.697-4.7462-1.6986z",
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudHosting);
export default __webpack_public_path__ + "static/media/cloud-hosting.20fd37e56731ea3f140418bb15b7f746.svg";
export { ForwardRef as ReactComponent };